import { render } from "./AppBtn.vue?vue&type=template&id=1322c9f4"
import script from "./AppBtn.vue?vue&type=script&lang=js"
export * from "./AppBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__